module.exports = __webpack_public_path__ + "static/media/rober12.5760d2b3.jpg";